import React from 'react';
import { connect } from 'react-redux';
import DatePickerValue from './datepicker';

import Breadcrumb from '../../breadcrumb/breadcrumb';

import BannerImg from '../../../images/img-default.png';
import InfomationIcon from '../../../images/Information.png';
import CorrectIcon from '../../../images/Correct.png';
import { updateDates, cleanClasses, initTest, disabledRedirect, updateTccValue, notificateClient } from '../../app/app.actions';
import Upload from './upload-new-ead';

import { confirmAlert } from 'react-confirm-alert';
import Loader from '../../spinner/spinner';

import 'react-confirm-alert/src/react-confirm-alert.css';
import { validSubmit } from '../../../utils/common-functions';

const STATUS = {
    OTHER: { status: 'OTHER', text: 'Sua certificação a um passo de distância! Faça o teste online e preencha os dados abaixo para ser aprovado!' },
    WAIT_CORRECTION: { status: 'WAIT_CORRECTION', text: 'Parabéns por ter passado na prova! No entanto, identificamos que os relatórios anexados estão com algumas sessões incompletas. Por favor, revise e complete os relatórios anexados para que possamos concluir a análise dos relatórios.' },
    NOT_APPROVED: { status: 'NOT_APPROVED', text: 'Sua certificação a um passo de distância! Faça o teste online e preencha os dados abaixo para ser aprovado!' },
    APPROVED_PENDING: { status: 'APPROVED_PENDING', text: 'Parabéns por ter passado na prova! Para concluirmos sua aprovação na turma, por favor, preencha os dados solicitados abaixo.' },
    APPROVED_REVISION: { status: 'APPROVED_REVISION', text: 'Parabéns por ter passado na prova! Você já preencheu todos os dados necessários. Agora, é só aguardar a análise dos relatórios anexados abaixo.' },
    APPROVED: { status: 'APPROVED', text: 'Parabéns! Você foi aprovado nesta turma!' },
};

let ArrayText = [
    {
        text: <React.Fragment><strong>Nome do Coach:</strong> preencha com o seu nome completo.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong>Conclusão 1º módulo em formação¹:</strong> preencha com a data de conclusão do
        primeiro módulo do curso de Formação em Coaching Integral Sistêmico.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong>Conclusão 2º módulo em formação¹:</strong> preencha com a data de conclusão do
        segundo módulo do curso de Formação em Coaching Integral Sistêmico.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong>Conclusão 1º módulo em formação³:</strong> preencha com a data de conclusão do
        primeiro módulo do curso de Formação Profissional em Business Coaching - ML5.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong>Conclusão 2º módulo em formação³:</strong> preencha com a data de conclusão do
        segundo módulo do curso de Formação Profissional em Business Coaching - ML5.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong>Conclusão em Master²:</strong> preencha com a data de conclusão do curso de Formação em Master
        Coaching.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong>RELATÓRIO DO CICLO COMPLETO DE SESSÕES FORMAÇÃO COACHING/COACH¹:</strong> realize um ciclo
         completo como <strong>Coach</strong>, com <strong>12 sessões.</strong> Anexar o relatório do ciclo de coaching com as 12 sessões nesse campo.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong>RELATÓRIO DO CICLO COMPLETO DE SESSÕES FORMAÇÃO COACHING/COACHEE¹:</strong> realize um ciclo completo
        como <strong>Coachee</strong>, com <strong>12 sessões.</strong> Anexar o relatório do ciclo de coaching com as 12 sessões nesse campo.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong>RELATÓRIO DO CICLO COMPLETO DE SESSÕES FORMAÇÃO PROFISSIONAL EM BUSINESS COACHING/COACH³ - ML5:</strong> realize um ciclo
         completo como <strong>Coach</strong>, com <strong>12 sessões.</strong> Anexar o relatório do ciclo de coaching com as 12 sessões nesse campo.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong>RELATÓRIO DO CICLO COMPLETO DE SESSÕES FORMAÇÃO PROFISSIONAL EM BUSINESS COACHING/COACHEE³ - ML5:</strong> realize um ciclo completo
        como <strong>Coachee</strong>, com <strong>12 sessões.</strong> Anexar o relatório do ciclo de coaching com as 12 sessões nesse campo.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong>RELATÓRIO DO CICLO COMPLETO DE SESSÕES DE MASTER COACHING/COACH²:</strong> realize um ciclo completo
        como <strong>Master Coach</strong>, com <strong>10 sessões.</strong> Anexar o relatório do ciclo de coaching com as 10 sessões nesse campo.</React.Fragment>,
    },
    {
        text: <React.Fragment><strong> Observações:</strong></React.Fragment>,
    },
    {
        text: <React.Fragment><strong> ¹ Obrigatório para teste de Formação em Coaching.</strong></React.Fragment>,
    },
    {
        text: <React.Fragment><strong> ² Obrigatório para teste de Formação em Master Coaching.</strong></React.Fragment>,
    },
    {
        text: <React.Fragment><strong> ³ Obrigatório para teste de Formação Profissional em Business Coaching.</strong></React.Fragment>,
    },
    {
        text: <React.Fragment><strong>¹ ² Obrigatórios para teste Unificado.</strong></React.Fragment>,
    },
];

class ListWrapper extends React.Component {

    state = {
        tests: [],
        isDisabled: true,
        hasChange: false,
        selectedSecondModEnd: '',
        selectedFirstModEnd: '',
        selectedMasterModEnd: '',
        coachName: '',
        isOcult: false,
    }

    setCurrentTccsState = (first, second, master, tests = [], isDisabled = false, coachName) => {
        this.setState({
            ...this.state,
            selectedSecondModEnd: second,
            selectedFirstModEnd: first,
            selectedMasterModEnd: master,
            isDisabled: isDisabled,
            tests: tests,
            coachName: coachName,
        });
    }

    componentDidMount() {
        const { classesNewEad = [], currentClasse, currentTccs = {} } = this.props;
        const currentClasseObject = classesNewEad.find(e=> currentClasse === e.class_id);
        this.setCurrentTccsState(
            currentTccs.finish_first_module_date,
            currentTccs.finish_second_module_date,
            currentTccs.finish_master_date,
            currentClasseObject ? currentClasseObject.tests : [],
            false,
            currentTccs.coach_name
        );
    }

    componentDidUpdate(prevProps) {
        const { currentTccs, currentClasse, classesNewEad = [], id } = this.props;

        if ((currentTccs !== prevProps.currentTccs ) || (currentClasse !== prevProps.currentClasse && id === 'online-test')) {
            const currentClasseObject = classesNewEad.find(e=> currentClasse === e.class_id);
            this.setCurrentTccsState(
                currentTccs.finish_first_module_date,
                currentTccs.finish_second_module_date,
                currentTccs.finish_master_date,
                currentClasseObject ? currentClasseObject.tests : [],
                false,
                currentTccs.coach_name
            );
        }
    }

    onSave = (firstMod = null, secondMod = null, masterEnd = null, coachName = null) => {
        this.props.updateDates({ finish_first_module_date: firstMod, finish_second_module_date: secondMod, finish_master_date: masterEnd, coach_name: coachName });
        this.setState({ ...this.state, tests: this.state.tests, hasChange: false });
    };

    onInit = (type) => {
        const { disabledRedirect, initTest } = this.props;
        disabledRedirect(true);
        initTest(type);
    }

    validFristDate = (date, callback) => {
        const { selectedSecondModEnd, selectedMasterModEnd } = this.state;
        let currentDate = date.toISOString();
        let message = undefined;

        if (selectedSecondModEnd && !(currentDate <= selectedSecondModEnd)) {
            message = 'Data deve ser inferior ao 2° modulo';
        }
        if (selectedMasterModEnd && !(currentDate <= selectedMasterModEnd)) {
            message = 'Data deve ser inferior ao modulo master';
        }
        if (message) {
            this.props.notificateClient(message);
        } else {
            this.setState({ ...this.state, selectedFirstModEnd: currentDate, hasChange: true });
            this.props.updateTccValue({ finish_first_module_date: currentDate });
            callback();
        }
    }

    validSecondDate = (date, callback) => {
        const { selectedFirstModEnd, selectedMasterModEnd } = this.state;
        let currentDate = date.toISOString();
        let message = undefined;

        if ( selectedFirstModEnd && !(currentDate >= selectedFirstModEnd)) {
            message = 'Data deve ser superior ao 1° modulo';
        }
        if ( selectedMasterModEnd && !(currentDate <= selectedMasterModEnd)) {
            message = 'Data deve ser inferior ao modulo master';
        }
        if (message) {
            this.props.notificateClient(message);
        } else {
            this.setState({ ...this.state, selectedSecondModEnd: currentDate, hasChange: true });
            this.props.updateTccValue({ finish_second_module_date: currentDate });
            callback();
        }
    }

    validMasterDate = (date, callback) => {
        const { selectedFirstModEnd, selectedSecondModEnd, tests } = this.state;
        let currentDate = date.toISOString();
        let message = undefined;

        if ((tests && tests.length === 1) && tests[0] === 'MASTER') {
            this.setState({ ...this.state, selectedMasterModEnd: currentDate, hasChange: true });
            this.props.updateTccValue({ finish_master_date: currentDate });
            callback();
        } else {
            if ( selectedFirstModEnd && selectedFirstModEnd > currentDate) {
                message = 'Data deve ser superior ao 1° e 2° modulo';
            }
            if ( selectedSecondModEnd && selectedSecondModEnd > currentDate) {
                message = 'Data deve ser superior ao 1° e 2° modulo';
            }
            if (message) {
                this.props.notificateClient(message);
            } else {
                this.setState({ ...this.state, selectedMasterModEnd: currentDate, hasChange: true });
                this.props.updateTccValue({ finish_master_date: currentDate });
                callback();
            }
        }
    }

    onChangeCoachName=(event) =>{
        let currentCoachName = event.target.value;
        if (currentCoachName && currentCoachName.length >= 3) {
            this.setState({ ...this.state, coachName: currentCoachName, hasChange: true });
            this.props.updateTccValue({ coach_name: currentCoachName });
        }
    };

    changeIsOcult = (e) => {
        e.preventDefault();
        this.setState({ ...this.state, isOcult: !this.state.isOcult });
    }

    onSubmit = () => {
        const { selectedFirstModEnd, selectedSecondModEnd, selectedMasterModEnd, coachName } = this.state;
        confirmAlert({
            customUI: ({ onClose }) => {
                return (
                    <div className='custom-ui'>
                        <h1>Você tem certeza disso?</h1>
                        <p>Ao enviar os dados eles estarão disponíveis para revisão pelo administrador. Deseja continuar?</p>
                        <div className='custom-ui-buttons' >
                            <button style={{ backgroundColor: 'red' }} onClick={onClose}>Não</button>
                            <button
                                style={{ backgroundColor: 'green' }}
                                onClick={() => {
                                    this.onSave(selectedFirstModEnd, selectedSecondModEnd, selectedMasterModEnd, coachName);
                                    onClose();
                                }}
                            >
                    Sim
                            </button>
                        </div>
                    </div>
                );
            },
        });
    };

    render() {
        const { children, id, disableRedirect, currentStatus, readOnly, lastSubmit = undefined, loadingOnlineTests, buttonSubmitDisabled } = this.props;
        const { selectedFirstModEnd, selectedSecondModEnd, selectedMasterModEnd, tests, coachName, isOcult } = this.state;
        return (
            <div style={{ height: '100%' }}>
                {
                    loadingOnlineTests
                        ? <Loader addClass='spinner-ead-tests' />
                        : <React.Fragment>
                            {this.renderBanner()}
                            <div className='class-description-wrapper'>
                                <div className='container-status' >
                                    <p className='description-title'>Descrição</p>
                                    { id === 'online-test' && <p className={`status-test ${currentStatus}`}>
                                        {this.renderIcon(currentStatus)}
                                        {
                                            STATUS[currentStatus].text || STATUS.OTHER.text
                                        }
                                    </p>
                                    }
                                </div>
                                {
                                    id === 'online-test'
                                        ? <React.Fragment>
                                            <p>
                                                Bem-vindo ao sistema de avaliação do EAD Febracis. Para concluir
                                                 sua formação e obter o seu certificado, você precisa preencher as informações abaixo
                                                e realizar um teste online, obtendo nota maior ou igual a 96%. A seguir explicamos
                                                o passo a passo para você.
                                                <a onClick={this.changeIsOcult} className='ocult-text' href='/#' >{ isOcult ? 'Ver mais' : 'Ocultar' }</a>
                                            </p>
                                            { !isOcult && (ArrayText.map((e, index)=>(<p key={index}>{e.text}</p>)))}
                                        </React.Fragment>
                                        : <React.Fragment>{this.renderDescription()}</React.Fragment>
                                }
                            </div>
                            {
                                id === 'online-test' &&
                        <div className='expiration tests-online-input-container'>
                            <label >Nome do coach:</label>
                            <input placeholder='Nome do coach' disabled={readOnly} readOnly={readOnly} type='text' defaultValue={coachName} onBlur={this.onChangeCoachName} />
                            <div className='inputs-container' style={{ justifyContent: tests.includes('MASTER') ? 'space-between' : 'space-around' }}>
                                <React.Fragment>
                                    {(tests.includes('FORMACAO') || tests.includes('UNIFICADO')) && (
                                        <React.Fragment>
                                            <div className= 'input-wrapper date-select triple-inputs ' >
                                                <DatePickerValue
                                                    label='Conclusão 1º módulo em formação'
                                                    readOnly={readOnly}
                                                    value={selectedFirstModEnd || null }
                                                    name='firstModule'
                                                    currentId='firstModule'
                                                    handlerChange={this.validFristDate}/>
                                            </div>
                                            <div className='input-wrapper date-select triple-inputs '>
                                                <DatePickerValue
                                                    label='Conclusão 2º módulo em formação:'
                                                    readOnly={readOnly}
                                                    value={selectedSecondModEnd || null }
                                                    name='secondModule'
                                                    currentId='secondModule'
                                                    handlerChange={this.validSecondDate}/>
                                            </div>
                                        </React.Fragment>
                                    )}
                                </React.Fragment>
                                { tests.includes('MASTER') &&
                                    (
                                        <div className='input-wrapper date-select triple-inputs '>
                                            <DatePickerValue
                                                label='Conclusão em Master:'
                                                readOnly={readOnly}
                                                value={selectedMasterModEnd || null }
                                                name='masterModule'
                                                currentId='masterModule'
                                                handlerChange={this.validMasterDate}/>
                                        </div>
                                    )
                                }

                            </div>
                            <div className='container-buttons-submit' >
                                <button
                                    className='submit-button'
                                    disabled={readOnly || !buttonSubmitDisabled}
                                    onClick={this.onSubmit}
                                >Submeter</button>
                                <p>{lastSubmit ? `Última atualização:  ${(new Date(lastSubmit)).toLocaleString()}` : ''}</p>
                            </div>
                        </div>
                            }
                            <div className='class-resources-wrapper'>
                                { id === 'online-test' ? <Upload tests={tests} readOnly={readOnly} /> : children }
                            </div>
                            { id === 'online-test' && (
                                <div className='container-buttons-test' style={{ justifyContent: tests.includes('MASTER') ? 'space-evenly' : 'center' }}>
                                    {tests.includes('FORMACAO') && <button disabled={disableRedirect} onClick={()=>this.onInit('FORMACAO')} className='submit-button'>INICIAR TESTE FORMAÇÃO</button>}
                                    {tests.includes('MASTER') && <button disabled={disableRedirect} onClick={()=>this.onInit('MASTER')} className='submit-button'>INICIAR TESTE MASTER</button>}
                                    {tests.includes('UNIFICADO') && <button disabled={disableRedirect} onClick={()=>this.onInit('UNIFICADO')} className='submit-button'>INICIAR TESTE UNIFICADO</button>}
                                </div>
                            )}
                        </React.Fragment>

                }
            </div>
        );
    }

    renderBanner = () => {
        const {
            picture,
            links,
        } = this.props;

        return (
            <div className='section-banner-wrapper'>
                <div className='section-banner'>
                    <img src={picture ? picture : BannerImg } alt='banner'/>
                </div>
                <div className='section-banner-foreground'>
                    <div className='section-breadcrumb'>
                        <Breadcrumb items={links}/>
                    </div>
                    {this.renderTitle()}
                </div>
            </div>
        );
    };

    renderIcon = (status) => {
        return (
            <img src={status === 'APPROVED' ? CorrectIcon : InfomationIcon } alt='banner' style={{ with: '24px', height: '24px' }}/>
        );
    };

    renderTitle = () => {
        const { title, courseName = '', className } = this.props;
        if (title !== null && title !== undefined) {
            return <span className='section-name'>{title}</span>;
        } else {
            return (
                <React.Fragment>
                    {(className === undefined) && <span className='course-name'>{courseName}</span>}
                    {(className !== undefined) && <span className='class-name'>{className}</span>}
                </React.Fragment>
            );
        }
    };

    renderDescription = () => {
        const { description = '' } = this.props;
        return description ? description.split('\n').map((p, i) => <p key={i}>{p}</p>) : '';
    };
}

const mapStateToProps = ({ App }) => {
    const currentClasseObject = App.classesNewEad.find(e=> App.currentClasse === e.class_id);
    let readOnly = false;
    if (currentClasseObject && currentClasseObject.status === STATUS.APPROVED.status) {
        readOnly = true;
    }

    let buttonSubmitDisabled = validSubmit(App.currentTccs, currentClasseObject ? currentClasseObject.tests : []);
    if (App.currentTccs.submitted && App.currentTccs.submitted === true) {
        buttonSubmitDisabled = false;
    }

    return {
        currentClasse: App.currentClasse,
        classesNewEad: App.classesNewEad,
        currentTccs: App.currentTccs,
        disableRedirect: App.disableRedirect,
        readOnly,
        buttonSubmitDisabled: currentClasseObject && currentClasseObject.status === 'WAIT_CORRECTION' ? true : buttonSubmitDisabled,
        lastSubmit: App.currentTccs && App.currentTccs.submitted_at,
        currentStatus: currentClasseObject ? currentClasseObject.status : 'OTHER',
        loadingOnlineTests: App.loadingOnlineTests || false,
    };
};

export default connect(mapStateToProps, { updateDates, initTest, notificateClient, cleanClasses, updateTccValue, disabledRedirect })(ListWrapper);



// WEBPACK FOOTER //
// ./src/components/section/components/list-wrapper.js